
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { OrderModel } from '@/models';

  @Component
  export default class CourierError extends Vue {
    @Prop() readonly order!: OrderModel;
  }
